<template>
  <SysDialog
    v-model="model"
    :largura="400"
    txt-botao="FECHAR"
    @click:primary="fechar"
  >
    <template #titulo>
      <div class="modal-produtos-header w-100-porcento d-flex align-center justify-space-between">
        <div class="d-flex align-center">
          <div class="d-flex align-center">
            <v-icon color="#f59e0b" size="20">mdi-alert-circle-outline</v-icon>

            <div class="modal-produtos-title ml-2 text-uppercase">
              Atenção
            </div>
          </div>
        </div>

        <v-btn icon small @click="fechar">
          <v-icon class="mr-n3" size="20" color="#707070">mdi-close</v-icon>
        </v-btn>
      </div>
    </template>

    <div class="mb-3 mt-n3">
      <div class="produtos-extra">
        {{ TOTAL_PRODUTOS_COMPUTED }} produto(s) está(ão) com os campos de fracionamento inválidos. [0 ou vazio]
      </div>

      <div
        v-for="(produto, index) in PRODUTOS_VISIVEIS_COMPUTED"
        :key="index"
        class="produto-row"
      >
        <div class="produto-col-nome">
          <div class="produto-nome-linha">
            {{ produto.idproduto }} - {{ produto.descricao }}
          </div>

          <div class="font-12 text-gray-300 mt-n1">
            Filial {{ produto.filial }}
          </div>
        </div>
      </div>

      <div
        v-if="PRODUTOS_EXTRAS_COMPUTED > 0"
        class="produtos-extra"
      >
        +{{ PRODUTOS_EXTRAS_COMPUTED }} produto(s)
      </div>

      <div class="alerta-box">
        <strong>Atenção:</strong>

        <p class="mt-2">
          O fracionamento de pedidos por <b>peso</b> ou <b>cubagem</b> pode ser impreciso caso os seguintes campos
          do cadastro do produto estejam 0 ou vazios:

          <span class="mt-1">
          <b>Peso</b>, <b>Comprimento</b>, <b>Altura</b> e <b>Largura</b>.
        </span>
        </p>
      </div>
    </div>
  </SysDialog>
</template>

<script>
import SysDialog from "@/components/padraoDeLayout/SysDialog.vue";

export default {
  name: 'DialogAlertaProdutosFracionamento',
  components: { SysDialog },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    produtos: {
      type: Array,
      default: () => [],
    },
    limiteExibicao: {
      type: Number,
      default: 3,
    },
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    TOTAL_PRODUTOS_COMPUTED() {
      return this.produtos.length;
    },
    PRODUTOS_VISIVEIS_COMPUTED() {
      return this.produtos.slice(0, this.limiteExibicao);
    },
    PRODUTOS_EXTRAS_COMPUTED() {
      return Math.max(this.TOTAL_PRODUTOS_COMPUTED - this.limiteExibicao, 0);
    },
  },
  methods: {
    fechar() {
      this.model = false;
    },
  },
}
</script>

<style scoped>
.modal-produtos-header {
  padding: 2px 0 10px;
}

.modal-produtos-title {
  font-size: 16px;
  font-weight: 700;
  color: #1f1f1f;
  line-height: 1.2;
}

.produto-row {
  display: flex;
  align-items: center;
  min-height: 46px;
  padding: 8px 14px;
  margin-bottom: 10px;
  border: 1px solid #dedede;
  border-radius: 7px;
  background: #fff;
}

.produto-col-nome {
  flex: 1;
  min-width: 0;
}

.produto-nome-linha {
  font-size: 15px;
  color: #111827;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.produtos-extra {
  margin: 5px 0 7px 0;
  font-size: 13px;
  color: #64748b;
}

.alerta-box {
  padding: 14px 16px;
  border: 1px solid #f2cc72;
  border-radius: 4px;
  background: #fff8e8;
  color: #b45309;
  font-size: 14px;
  line-height: 1.5;
  text-align: justify;
}
</style>
